import SchoolPolicies from "./SchoolPolicies";
export default SchoolPolicies;
